<div *ngIf="notice" class="item-container" (click)="openNoticeClicked(notice)">

    <app-notice-item-detail [notice]="notice">
    </app-notice-item-detail>

</div>
